<template>
    <div>
        <fusioncharts
            type="doughnut2d"
            width="100%"
            height="300"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: ['data'],

        data () {
            return {
                dataSource: {
                    chart: {
                        bgColor: "#edf2f7",
                        caption: "",
                        defaultCenterLabel: "Project Stage",
                        centerLabel: "$label",
                        showPercentValues: "1",
                        plotToolText: "<b>$percentValue</b> - $label",
                        plotHighlightEffect: "fadeout",
                        showLegend: "1",
                        legendPosition: "bottom",
                        legendItemFontSize: "13",
                        legendIconScale: ".8",
                        usedAtAPlotColorForLabels: "1",
                        theme: "fusion"
                    },
                    data: this.data
                }
            }
        },
    }
</script>